<template lang="pug">
  v-select(
    :value="value"
    :items="directions"
    item-value="id"
    item-text="name"
    name="direction"
    label="Направленность"
    filled
    rounded
    v-bind="$attrs"
    @input="$emit('input', $event)"
  )
</template>

<script>
import SystemService from '@/services/API/SystemService';

export default {
  name: 'DirectionSelect',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    directions: [],
  }),
  created() {
    this.loadDirections();
  },
  methods: {
    loadDirections() {
      this.$rHandler(
        SystemService.getDirections(),
        (r) => { this.directions = r.data.data; },
      );
    },
  },
};
</script>
